import { render, staticRenderFns } from "./GlobalCheckout.vue?vue&type=template&id=7f89ba6a&scoped=true"
import script from "./GlobalCheckout.vue?vue&type=script&lang=js"
export * from "./GlobalCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f89ba6a",
  null
  
)

export default component.exports